<template>
    <div
    >
      <h2 class="font-medium text-base md:text-xl">Change your password</h2>
      <FocusTrap>
        <form class="bg-white shadow rounded mt-6 md:mt-12" @submit.prevent="submit">
          <div class="mb-5 px-8 py-6">
            <AgInput
              v-validate="'required'"
              class="mb-4 w-full"
              type="password"
              label="Current Password"
              name="current_password"
              placeholder="Enter your current password"
              v-model="model.current_password"
              :has-error="errors.has('current_password')"
            >
              <span class="text-sm text-red-600">
                {{ errors.first("current_password") }}
              </span>
            </AgInput>
            <AgInput
              v-validate="'required'"
              class="mb-4 w-full"
              type="password"
              label="New Password"
              name="password"
              placeholder="Enter nice new password"
              v-model="model.password"
              ref="password"
              :has-error="errors.has('password')"
            >
              <span class="text-sm text-red-600">
                {{ errors.first("password") }}
              </span>
            </AgInput>
            <AgInput
              v-validate="'required|confirmed:password'"
              class="mb-4 w-full"
              type="password"
              label="Confirm New Password"
              name="password_confirmation"
              placeholder="Confirm your new password"
              v-model="model.confirm_password"
              data-vv-as="password"
              :has-error="errors.has('password_confirmation')"
            >
              <span class="text-sm text-red-600">
                {{ errors.first("password_confirmation") }}
              </span>
            </AgInput>
          </div>
          <div class="mt-2 flex flex-col md:flex-row bg-gray-100 px-8 py-4 items-center border-t gap-4">
            <button
              @click.prevent="submit"
              class="w-full md:w-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 md:py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >Save Changes</button>
            <button
              @click.prevent="cancel"
              class="w-full md:w-auto text-white bg-slate-400 font-medium py-3 md:py-2 px-4 rounded focus:outline-none focus:shadow-outline content-end"
            >Cancel</button>
          </div>
        </form>
      </FocusTrap>
    </div>
</template>
<script>
  import AgInput from "@/components/Input/Input.vue";
  import axios from "axios";
  import FocusTrap from "vue-focus-lock";

  export default {
    name: "ChangePassword",
    components: {
      AgInput,
      FocusTrap
    },
    data() {
      return {
        model: {
          current_password: '',
          password: '',
          confirm_password: '',
        }
      };
    },
    methods: {
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$loading(true);
            axios
              .post("/api/change-password", this.model)
              .then(() => {
                this.$loading(false);
                this.$toasted.success("Password changed successfully !");
              })
              .catch(error => {
                this.$loading(false);
                const errors = error.response.data;
                const status = error.response.status;
                if (status === 422) {
                  let errorFields = Object.keys(errors);
                  for (let i = 0; i < errorFields.length; i++) {
                    let field = errorFields[i];

                    let errorString = errors[field][0];
                    this.$validator.errors.add({
                      field: field,
                      msg: errorString
                    });
                  }
                  return;
                }
                this.$toasted.error("Oops, Something went wrong..");
              });
          }
        });
      },
      cancel() {
        this.$router.back();
      }
    }
  };
</script>
